import React from "react"

export const MethodColumnSpanner = ({ name, colSpan, method_info, onMethodClick }) => {
  return (
    <td
      colSpan={colSpan}
      className={"text-center method-col-spanner"}
      onClick={(e) => {
        e.stopPropagation()
        method_info && onMethodClick && onMethodClick()
      }}
      style={{ fontSize: "90%" }}
    >
      {`${name}${method_info?.slims ? " (SLIMS)" : ""}`}
      {method_info?.description && `: ${method_info?.description}`}
      &nbsp;&nbsp;
      {(method_info?.test_items || []).length > 0 && (
        <>
          {!method_info?.open ? (
            <span className={"fa fa-caret-up"} />
          ) : (
            <span className={"fa fa-caret-down"} />
          )}
        </>
      )}
    </td>
  )
}
